module.exports = __webpack_public_path__ + "img/switzerland-transport-accidents-male.f724077d.png";